// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".classwork-editor-header {\n  text-align: center;\n  font-size: 16px;\n  line-height: 24px;\n}", ""]);
// Exports
module.exports = exports;
